import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './StoryboardDetail.module.css';

const StoryboardDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const storyboardData = {
    1: { title: 'Story 1', type: 'Ad Film', image: '/images/story-1.jpg', description: 'A compelling advertisement storyboard showcasing product features through visual storytelling.', link: 'https://example.com/ad1' },
    2: { title: 'Story 2', type: 'Short Film', image: '/images/story-2.jpg', description: 'An emotional short film storyboard exploring human connections and relationships.', link: 'https://example.com/film2' },
    3: { title: 'Story 3', type: 'Ad Film', image: '/images/story-3.jpg', description: 'Dynamic commercial storyboard with engaging visual sequences.', link: 'https://example.com/ad3' },
    4: { title: 'Story 4', type: 'Short Film', image: '/images/story-4.jpg', description: 'Narrative-driven storyboard for an independent short film project.', link: 'https://example.com/film4' },
    5: { title: 'Story 5', type: 'Ad Film', image: '/images/story-5.jpg', description: 'Creative advertisement storyboard with innovative visual concepts.', link: 'https://example.com/ad5' },
    6: { title: 'Story 6', type: 'Short Film', image: '/images/story-6.jpg', description: 'Artistic storyboard for a thought-provoking short film.', link: 'https://example.com/film6' },
    7: { title: 'Story 7', type: 'Ad Film', image: '/images/story-7.jpg', description: 'Brand-focused storyboard with strategic visual messaging.', link: 'https://example.com/ad7' },
  };

  const story = storyboardData[id];

  if (!story) {
    return <div>Storyboard not found</div>;
  }

  return (
    <>
      <Header />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <span className={styles.badge}>{story.type}</span>
            <h1 className={styles.title}>{story.title}</h1>
            <p className={styles.description}>{story.description}</p>
          </div>

          <div className={styles.imageContainer}>
            <img src={story.image} alt={story.title} className={styles.image} />
          </div>

          <div className={styles.actions}>
            <a href={story.link} target="_blank" rel="noopener noreferrer" className={styles.linkButton}>
              <ExternalLink />
              View Project
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StoryboardDetail;
